import axios from 'axios'
import { store } from './vuex'
import ObjectHelper from "~/helpers/ObjectHelper";

const pending = {};

axios.interceptors.request.use(function (request) {
    request.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    request.headers.common['authorization'] = 'Bearer ' + store.getters['auth/getAccessToken'];

    // ValidateRequestedMarket refuses an agent without it. It is unknown until
    // `/api/users/current` has answered, which is one of the few ungated endpoints.
    const market = store.getters['auth/getMarket'];
    if (market) {
        request.headers.common['Ambassador-Market'] = market;
    }

    if (request.url in pending) {
        let pendingRequest = pending[request.url];
        if (request.url.includes('filter-search')) {
            pendingRequest.cancel();
        } else {
            if (
                request.url === pendingRequest.url &&
                ObjectHelper.compareObjects(request.params, pendingRequest.params) &&
                ObjectHelper.compareObjects(request.data, pendingRequest.data) &&
                request.method === pendingRequest.method
            ) {
                pendingRequest.cancel();
            }
        }
    }

    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
    request.cancelToken = source.token;
    request.cancel = source.cancel;
    pending[request.url] = request;

    return request;
});

axios.interceptors.response.use(function (response) {
    return response;
}, async function (error) {
    if (axios.isCancel(error)) {
        return Promise.reject(error);
    }
    if (error.response && error.response.status == 401 && !error.request.responseURL.includes('oauth/token'))
    {
        if (await store.dispatch('auth/tokenIsExpired')) {
            if (store.state.auth.hasOwnProperty('token') &&
                store.state.auth.token &&
                store.state.auth.token.constructor === Object &&
                store.state.auth.token.hasOwnProperty('refresh_token') &&
                store.state.auth.token.refresh_token !== null) {
                let response = await store.dispatch('auth/refresh');
            }

            if (!await store.dispatch('auth/tokenIsExpired')) {
                let retryRequest = error.request;
                retryRequest.headers.authorization = 'Bearer ' + store.getters['auth/getAccessToken'];
                // retry request
                let response = axios({...retryRequest});
                return response;
            }
        }

        localStorage.clear();
        window.location.href = "/manage";
    }

    return Promise.reject(error);
});

export {axios as axios};
